/*jshint esversion: 6 */

export function getFileNameFromUrl(url){
    var groupArr = url.split('/');
    const gl = groupArr.length;
    let en = '';
    if(gl > 0){
        en= groupArr[gl-1]
    }
    return en;
}



// WEBPACK FOOTER //
// ./src/utils/manusFuncs.js